import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Login from "./Login";
import ModalTemplate from "./ModalWrapper";
import SignUp from "./SignUp";

type AuthMode = "login" | "signup";

interface AuthModalPageProps {
  initialMode: AuthMode;
}

const AuthModalPage = ({ initialMode }: AuthModalPageProps) => {
  const [mode, setMode] = useState<AuthMode>(initialMode);
  const navigate = useNavigate();

  useEffect(() => {
    setMode(initialMode);
  }, [initialMode]);

  const handleClose = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate("/", { replace: true });
  };

  return (
    <main className="min-h-screen bg-[#FAFAFA]">
      <ModalTemplate
        showModal
        mobileBottomSheet
        className="!w-full !bg-white !px-0 !py-0 tablet:!w-[340px] tablet:!rounded-3xl tablet:!border tablet:!border-gray-200 tablet:!shadow-main desktop:!w-[440px]"
        onClose={handleClose}
        mainComponent={
          mode === "login" ? (
            <Login
              onClose={handleClose}
              switchToSignup={() => setMode("signup")}
            />
          ) : (
            <SignUp
              onClose={handleClose}
              switchToLogin={() => setMode("login")}
            />
          )
        }
      />
    </main>
  );
};

export default AuthModalPage;
